import type { FulfillmentOrderLine, FulfillmentResourceMentionCandidate, FulfillmentSupplierOption, FulfillmentTransportPoint } from "../types";

export type EntryCategory = "stay" | "air" | "bus" | "ticket" | "meal" | "crew" | "misc";
export type EntryProvider = FulfillmentSupplierOption | FulfillmentResourceMentionCandidate | { id: string; name: string; snapshotResourceType: string };
export type EntryParseInput = {
  category: EntryCategory;
  text: string;
  range: string;
  routeDays: ReadonlyArray<{ dayNo: number; date: string | null }>;
  candidates: readonly FulfillmentResourceMentionCandidate[];
  provider?: EntryProvider | null;
  settlement?: Pick<FulfillmentSupplierOption, "id" | "name"> | null;
  point?: FulfillmentResourceMentionCandidate | null;
  fromPoint?: FulfillmentTransportPoint | null;
  toPoint?: FulfillmentTransportPoint | null;
  roleCounts?: Partial<Record<string, number>>;
  allowZeroQuantity?: boolean;
};
export type EntryPreviewItem = { key: string; sourceStart: number; sourceEnd: number; raw: string; title: string; formula: string; patch: Partial<FulfillmentOrderLine>; notices: string[] };
export type EntryIssueField = "range" | "provider" | "resource" | "formula";
export type EntryParseResult = { items: EntryPreviewItem[]; errors: Array<{ sourceStart: number; sourceEnd: number; raw: string; message: string; field: EntryIssueField; origin?: "control" | "text" }> };
export type EntryExistingDraft = { base: FulfillmentOrderLine; patch: Partial<FulfillmentOrderLine>; removed: boolean };
export type EntryBatchChange = { updates: Array<{ id: string; patch: Partial<FulfillmentOrderLine> }>; additions: Partial<FulfillmentOrderLine>[]; removals: string[] };
export const ENTRY_RESOURCE_TYPES: Record<EntryCategory, string> = { stay: "住宿", air: "大交通", bus: "包车", ticket: "考察点", meal: "餐", crew: "导游", misc: "杂费" };

/** 分类入口直接接收自己的业务上下文，无须再次传入分类。 */
export type EntryParseBaseInput = Omit<EntryParseInput, "category">;
